import React, { useMemo, useState } from "react";
import PageHeader from "../../shared/PageHeader";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useSelector } from "react-redux";
import RadiologyOrderTable from "../../components/radiology/RadiologyOrderTable";
import { FaXRay } from "react-icons/fa6";
import { useGetRadiologyOrdersQuery } from "../../redux/api/modules/ordersApi";

function RadiologyOrders() {
  const { t } = useTranslation();
  const selectedPatientData = useSelector(
    (state) => state?.beneficiary?.seletedPatientData
  );
  const [payload, setPayload] = useState({
    page: 1,
    per_page: 10,
    from_date: moment().subtract(1, "month").format("YYYY-MM-DD"),
    to_date: moment().format("YYYY-MM-DD"),
    patient_id: selectedPatientData?.patient_id || "",
  });
  const queryPayload = useMemo(() => {
    const { from_date, to_date, ...rest } = payload;
    return {
      ...rest,
      start_date: from_date,
      end_date: to_date,
    };
  }, [payload]);

  const { data: resData, isLoading, isFetching, refetch } = useGetRadiologyOrdersQuery(queryPayload);
  const loading = isLoading || isFetching;

  const fetchInitialData = (payloadData) => {
    if (payloadData) {
      setPayload(payloadData);
    } else {
      refetch();
    }
  };

  return (
    <div className="main-page-container !overflow-y-auto scrollbar">
      <PageHeader title={t("Radiology Orders")} iconSize={20} Icon={FaXRay} />
      <div className="mt-2 w-full h-full ">
        <RadiologyOrderTable
          data={resData?.data || {}}
          payload={payload}
          setPayload={setPayload}
          loading={loading}
          fetchInitialData={fetchInitialData}
        />
      </div>
    </div>
  );
}

export default RadiologyOrders;
